import React from "react";
import { applyClassName, styled } from "@glitz/react";
import { useCart, cartItemIsOnBackorder } from "../context/CartContext";
import { GrFormTrash } from "react-icons/gr";
import { spacing, green, fontSize, fontWeight, grey, lightGrey, orange, darkGrey } from "../theme";
import SlimQuantitySelector from "./basic/SlimQuantitySelector";

const CheckoutCart: React.FC = () => {
  const { cart, removeFromCart, updateItemQuantity } = useCart();

  return (
    <Wrapper>
      <HeaderRow>
        <HeaderCell />
        <HeaderCell />
        <HeaderCell css={textAlignCenterDecorator}>Antal</HeaderCell>
        <HeaderCell>Á-pris</HeaderCell>
        <HeaderCell>Summa</HeaderCell>
        <HeaderCell />
      </HeaderRow>

      {cart.length > 0 ? (
        cart.map((item, index) => (
          <React.Fragment key={item.id}>
            <Row>
              <ImgCell>
                <Img src={item.img} loading="lazy" decoding="async" />
              </ImgCell>
              <NameCell>
                {item.name}
                {cartItemIsOnBackorder(item) && (
                  <BackorderLine>Beställningsvara – skickas när den finns i lager.</BackorderLine>
                )}
              </NameCell>
              <QuantityCell>
                <SlimQuantitySelector
                  initialQuantity={item.quantity}
                  onAdd={() => updateItemQuantity(item.id, item.quantity + 1)}
                  onSubtract={() =>
                    updateItemQuantity(item.id, item.quantity - 1)
                  }
                />
              </QuantityCell>
              <PriceCell>{item.price} kr</PriceCell>
              <PriceCell>{item.price * item.quantity} kr</PriceCell>
              <ActionCell>
                <TrashIcon onClick={() => removeFromCart(item.id)} />
              </ActionCell>
            </Row>
            {index < cart.length - 1 && <Divider />}
          </React.Fragment>
        ))
      ) : (
        <EmptyText>Din varukorg är tom</EmptyText>
      )}
    </Wrapper>
  );
};

const GRID_COLUMNS = "70px 1fr 120px 80px 80px 40px";

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

const HeaderRow = styled.div({
  display: "grid",
  gridTemplateColumns: GRID_COLUMNS,
  gap: spacing.m,
  alignItems: "center",
  fontWeight: fontWeight.bold,
  fontSize: fontSize.s,
  borderBottom: { style: "solid", color: grey, width: "2px" },
  paddingBottom: spacing.xs,
});

const Row = styled.div({
  display: "grid",
  gridTemplateColumns: GRID_COLUMNS,
  gap: spacing.m,
  alignItems: "center",
  padding: { y: spacing.s },
});

const HeaderCell = styled.div({
  textAlign: "right",
});

const textAlignCenterDecorator = styled({
  textAlign: "center",
});

const ImgCell = styled.div({
  width: "70px",
  height: "70px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const Img = styled.img({
  maxWidth: "100%",
  maxHeight: "100%",
  width: "auto",
  height: "auto",
  objectFit: "contain",
  display: "block",
});

const NameCell = styled.div({
  fontSize: fontSize.m,
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
  minWidth: 0,
  overflow: "hidden",
  paddingLeft: spacing.xs,
});

const BackorderLine = styled.div({
  fontSize: fontSize.s,
  fontWeight: fontWeight.light,
  color: darkGrey,
  borderLeft: { style: "solid", color: orange, width: "3px" },
  paddingLeft: spacing.xs,
  lineHeight: 1.35,
});

const QuantityCell = styled.div({
  display: "flex",
  justifyContent: "flex-end",
});

const PriceCell = styled.div({
  textAlign: "right",
  fontSize: fontSize.m,
  fontWeight: fontWeight.bold,
  whiteSpace: "nowrap",
});

const ActionCell = styled.div({
  display: "flex",
  justifyContent: "center",
});

const TrashIcon = styled(applyClassName(GrFormTrash), {
  fontSize: "25px",
  color: green,
  cursor: "pointer",
});

const Divider = styled.div({
  borderBottom: { style: "solid", color: lightGrey, width: "1px" },
});

const EmptyText = styled.div({
  padding: { y: spacing.l },
  textAlign: "center",
});

export default CheckoutCart;
